<template>
  <div>
    <info-box v-bind:description="description"></info-box>
    <slider></slider>
  </div>
</template>

<script>
import slider from './slider'
export default {
  name: 'Home',
  components: {
    slider
  },
  data () {
    return {
      description: {
        title: 'Welcome!',
        text: 'Check on bets, leaderboards, bounties, and lottery ticket purchases. Login with your twitch to get easy access to your info!'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue